function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-radius: 4px;\n  box-shadow: 0px 0px 40px 20px rgba(0, 0, 0, 0.05);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from "styled-components";
import { Card as BaseCard } from "@diana-ui/card";
var Card = styled(BaseCard)(_templateObject());
export default Card;